import { Button, Group, Menu } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconCheck, IconX } from "@tabler/icons-react";
import { Fragment, useState } from "react";
import { BasicConfirmationModal } from "../../BuildingBlocks/Layout/Modals/BasicConfirmationModal/BasicConfirmationModal";
import type { GeneratorFeatureKeys } from "../../ComponentListContainer/ComponentList/ComponentEditWizard/Data/utils/getGeneratorFeatures";
import { GENERATOR_FEATURES } from "../../ComponentListContainer/ComponentList/ComponentEditWizard/Data/utils/getGeneratorFeatures";
import { useShouldShowStaffView } from "../../StaffViewToggle/useShouldShowStaffView";

interface GeneratorsPageTableBatchActionsProps {
  batchIsDisabled: boolean;
  handleChangeStatusBatchVerificationItems: (
    key: GeneratorFeatureKeys,
    value: boolean
  ) => void;
}

function GeneratorsPageTableBatchActions({
  batchIsDisabled,
  handleChangeStatusBatchVerificationItems
}: GeneratorsPageTableBatchActionsProps) {
  const { shouldShowStaffView: isStaff } = useShouldShowStaffView();
  const [isConfirmationOpen, { open, close, toggle }] = useDisclosure(false);
  const [pendingAction, setPendingAction] = useState<{
    key: GeneratorFeatureKeys;
    confirmationText?: string;
    label: string;
  } | null>(null);

  function handleActionSelect(
    key: GeneratorFeatureKeys,
    value: boolean,
    label: string,
    confirmationText?: string
  ) {
    if (value) {
      handleChangeStatusBatchVerificationItems(key, value);
      return;
    }

    setPendingAction({ key, confirmationText, label });
    open();
  }

  function handleConfirm() {
    if (!pendingAction) return;

    handleChangeStatusBatchVerificationItems(pendingAction.key, false);
    setPendingAction(null);
    close();
  }
  return (
    <>
      <Group>
        <Menu position="bottom-end">
          <Menu.Target>
            <Button disabled={batchIsDisabled}>Sammelaktion</Button>
          </Menu.Target>
          <Menu.Dropdown>
            {GENERATOR_FEATURES.filter(
              (feature) => isStaff || !feature.staffOnly
            ).map((option) => (
              <Fragment key={option.key}>
                <Menu.Label>{option.label}</Menu.Label>
                <Menu.Item
                  aria-label={`Schalte ${option.label} an für ausgewählte Erzeuger`}
                  onClick={() =>
                    handleChangeStatusBatchVerificationItems(option.key, true)
                  }
                >
                  <Group>
                    <IconCheck size={14} />
                    Alle selektierten anwählen
                  </Group>
                </Menu.Item>
                <Menu.Item
                  aria-label={`Schalte ${option.label} aus für ausgewählte Erzeuger`}
                  onClick={() =>
                    handleActionSelect(
                      option.key,
                      false,
                      option.label,
                      option.confirmationText
                    )
                  }
                >
                  <Group>
                    <IconX size={14} />
                    Alle selektierten abwählen
                  </Group>
                </Menu.Item>
              </Fragment>
            ))}
          </Menu.Dropdown>
        </Menu>
      </Group>
      <BasicConfirmationModal
        cancelButtonText="Abbrechen"
        confirmationButtonText="Ja, deaktivieren"
        opened={isConfirmationOpen}
        title={pendingAction?.label}
        toggleModal={toggle}
        onCancel={() => {
          setPendingAction(null);
          close();
        }}
        onConfirm={handleConfirm}
      >
        {pendingAction?.confirmationText ||
          (pendingAction?.label
            ? `Möchten Sie die Funktion "${pendingAction.label}" wirklich deaktivieren?`
            : undefined)}
      </BasicConfirmationModal>
    </>
  );
}

export { GeneratorsPageTableBatchActions };
